var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_80",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 11,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78751 1.65791C2.98617 1.47731 3.28956 1.47731 3.48821 1.65791L5.32155 3.32458C5.53439 3.51807 5.55007 3.84747 5.35658 4.06031C5.16309 4.27315 4.83369 4.28884 4.62085 4.09535L3.6587 3.22066V9.54329C3.6587 9.83094 3.42551 10.0641 3.13786 10.0641C2.85021 10.0641 2.61703 9.83094 2.61703 9.54329V3.22066L1.65488 4.09535C1.44204 4.28884 1.11264 4.27315 0.919143 4.06031C0.72565 3.84747 0.741336 3.51807 0.954178 3.32458L2.78751 1.65791ZM8.05681 1.52246C8.34446 1.52246 8.57764 1.75565 8.57764 2.04329V8.36592L9.53979 7.49124C9.75263 7.29775 10.082 7.31343 10.2755 7.52628C10.469 7.73912 10.4533 8.06852 10.2405 8.26201L8.40716 9.92868C8.2085 10.1093 7.90511 10.1093 7.70646 9.92868L5.87312 8.26201C5.66028 8.06852 5.6446 7.73912 5.83809 7.52628C6.03158 7.31343 6.36098 7.29775 6.57382 7.49124L7.53597 8.36592V2.04329C7.53597 1.75565 7.76916 1.52246 8.05681 1.52246Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.598999,
    y: 0.793457,
    width: 10,
    height: 10,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a6753d7318a268c0ebc73dab6ea576e4.svg";
export { ForwardRef as ReactComponent };